<div class="flights-dialog">
  <div class="dialog-header">
    <div class="header-copy">
      <span class="header-eyebrow">Programación</span>
      <h2 class="dialog-title">{{ copy.title }}</h2>
      <p class="dialog-subtitle">{{ copy.subtitle }}</p>
    </div>
    <button
      mat-icon-button
      type="button"
      class="header-close"
      aria-label="Cerrar"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="body" [class.has-pax-panel]="showPaxPanel">
    <div *ngIf="isLoading" class="loading-state">
      <mat-progress-spinner mode="indeterminate" diameter="42"></mat-progress-spinner>
      <div class="state-copy">
        <h3>{{ copy.loading }}</h3>
        <p>{{ copy.loadingHint }}</p>
      </div>
    </div>

    <div *ngIf="showEmpty" class="empty-state">
      <mat-icon>flight_takeoff</mat-icon>
      <p class="empty-message">{{ copy.empty }}</p>
      <p class="empty-hint">{{ copy.emptyHint }}</p>
    </div>

    <ng-container *ngIf="showTable">
      <div class="summary-bar">
        <span class="summary-chip">
          {{ copy.flightsChipLabel }}
          <strong>{{ flightCount }}</strong>
        </span>
        <span class="summary-hint" *ngIf="!showPaxPanel">{{ copy.paxPanelHint }}</span>
      </div>

      <div class="table-layout">
        <div class="flights-table-wrapper">
          <table
            mat-table
            [dataSource]="flightDataSource"
            matSort
            (matSortChange)="announceSortChange($event)"
            class="flights-table"
          >
            <colgroup>
              <col class="col-nrovuelo" />
              <col class="col-aerolinea" />
              <col class="col-status" />
              <col class="col-fecha" />
              <col class="col-time" />
              <col class="col-time" />
              <col class="col-airport" />
              <col class="col-airport" />
              <col class="col-pax" />
            </colgroup>

            <ng-container matColumnDef="NroVuelo">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                sortActionDescription="Ordenar por número de vuelo"
              >
                {{ headers.NroVuelo }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="custom-td col-flight-number"
                [title]="element.flightNumber || ''"
              >
                <span class="flight-number">{{ element.flightNumber || copy.fallbackDash }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="aerolinea">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ headers.aerolinea }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="custom-td"
                [title]="element.airline || copy.fallbackDash"
              >
                {{ element.airline || copy.fallbackDash }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ headers.status }}
              </th>
              <td mat-cell *matCellDef="let element" class="status-cell">
                <span class="status-badge" [ngClass]="getStatusClass(element?.estado)">
                  {{ element?.estado || copy.fallbackDash }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="fechaVuelo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ headers.fechaVuelo }}
              </th>
              <td mat-cell *matCellDef="let element" class="custom-td col-date">
                {{
                  element?.flightDate
                    ? (element.flightDate | date: 'dd/MM/yyyy')
                    : copy.fallbackDash
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="departureTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ headers.departureTime }}
              </th>
              <td mat-cell *matCellDef="let element" class="custom-td col-time">
                {{
                  element?.departureTime
                    ? getHourFromDate(element.departureTime)
                    : copy.fallbackDash
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="arrivalTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ headers.arrivalTime }}
              </th>
              <td mat-cell *matCellDef="let element" class="custom-td col-time">
                {{
                  element?.arrivalTime
                    ? getHourFromDate(element.arrivalTime)
                    : copy.fallbackDash
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="origen">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ headers.origen }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="custom-td col-airport"
                [title]="formatAirport(element?.departureAirport)"
              >
                {{ formatAirport(element?.departureAirport) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="destino">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ headers.destino }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="custom-td col-airport"
                [title]="formatAirport(element?.arrivalAirport)"
              >
                {{ formatAirport(element?.arrivalAirport) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="pax">
              <th mat-header-cell *matHeaderCellDef>
                {{ headers.pax }}
              </th>
              <td mat-cell *matCellDef="let element" class="pax-cell">
                <ng-container *ngIf="getPaxEntries(element).length; else noPax">
                  <button
                    type="button"
                    class="pax-trigger"
                    [class.is-active]="isFlightPaxSelected(element)"
                    [attr.aria-expanded]="isFlightPaxSelected(element)"
                    [attr.aria-label]="
                      copy.paxViewList + ' — ' + getPaxCountLabel(getPaxEntries(element).length)
                    "
                    (click)="togglePaxPanel(element, $event)"
                  >
                    <span class="pax-count">{{ getPaxEntries(element).length }}</span>
                    <span class="pax-trigger-copy">
                      <span class="pax-trigger-label">{{ copy.paxViewList }}</span>
                      <span class="pax-trigger-meta">
                        {{ getPaxCountLabel(getPaxEntries(element).length) }}
                      </span>
                    </span>
                    <mat-icon class="pax-trigger-icon">chevron_right</mat-icon>
                  </button>
                </ng-container>
                <ng-template #noPax>{{ copy.fallbackDash }}</ng-template>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [class.row-pax-active]="isFlightPaxSelected(row)"
            ></tr>
          </table>
        </div>

        <aside class="pax-panel" *ngIf="showPaxPanel" aria-live="polite">
          <div class="pax-panel-header">
            <div class="pax-panel-heading">
              <span class="pax-panel-eyebrow">{{ copy.paxPanelTitle }}</span>
              <h3 class="pax-panel-flight">{{ getSelectedFlightLabel() }}</h3>
              <p class="pax-panel-meta">
                {{ getPaxCountLabel(selectedFlightPaxEntries.length) }}
              </p>
            </div>
            <button
              mat-icon-button
              type="button"
              class="pax-panel-close"
              [attr.aria-label]="copy.paxPanelClose"
              (click)="closePaxPanel()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <div class="pax-panel-body">
            <ol class="pax-panel-list">
              <li *ngFor="let entry of selectedFlightPaxEntries; let index = index">
                <span class="pax-index">{{ index + 1 }}</span>
                <span class="pax-name">{{ entry.name }}</span>
              </li>
            </ol>
          </div>
        </aside>
      </div>
    </ng-container>
  </div>

  <div class="footer-actions">
    <button mat-raised-button class="close-button" type="button" (click)="close()">
      {{ copy.footerClose }}
    </button>
  </div>
</div>
